import angular from 'angular';
/* Module Imports */
import jobSchedulesJobModule from './jobschedules/jobschedules.module';
import reportViewModule from './reportview/reportview.module';

/* Additional Imports */
import ReportsRouteConfig from './reports.route';

import ReportingService from './services/reporting.service';

import ReportsListComponent from './reports-list/reports-list.component';
import InteractiveReportComponent from './interactive-report-view/interactive-report-view.component';

import ReportsController from './reports.controller';
import FilterViewController from './filters/filters-view/filters-view.component';
import FilterDatePicker from './filters/filter-date-picker/filter-date-picker.component';
import MultiSelectDropdownController from './filters/multi-select-dropdown/multi-select-dropdown.component';
import SingleSelectDropdownController from './filters/single-select-dropdown/single-select-dropdown.component';
import FilterTextInputComponent from './filters/filter-text-input/filter-text-input.component';
import ExportOptionsPopupController from "./export-options-popup/export-options-popup.controller";
import DeleteCustomViewPopupController from './delete-custom-view-popup/delete-custom-view-popup.controller'
import OverwriteCustomViewPopupController from './overwrite-cutom-view-popup/overwrite-custom-view-popup.controller'

const reportsModule = angular
  .module('app.reports', ['ui.bootstrap', 'ui.router', 'gettext', jobSchedulesJobModule, reportViewModule])
  .config(ReportsRouteConfig)
  .controller('ReportsController', ReportsController)
  .controller('ExportOptionsPopupController', ExportOptionsPopupController)
  .controller('DeleteCustomViewPopupController', DeleteCustomViewPopupController)
  .controller('OverwriteCustomViewPopupController', OverwriteCustomViewPopupController)

  .service('reportingService', ReportingService)

  .component('reportsList', ReportsListComponent)
  .component('interactiveReport', InteractiveReportComponent)
  .component('filtersView', FilterViewController)
  .component('filterDatePicker', FilterDatePicker)
  .component('multiSelectDropdown', MultiSelectDropdownController)
  .component('singleSelectDropdown', SingleSelectDropdownController)
  .component('filterTextInput', FilterTextInputComponent);

export default reportsModule.name;
